<template>
  <div>
    <div class="mb-2 justify-content-center d-flex">
      <img
        class="align-self-center"
        src="@/assets/images/success_password.png"
        alt=""
        height="40"
        width="40"
      />
    </div>

    <h3 class="mb-2 text-center">Successfully Changed Password</h3>

    <div class="mb-4">
      Your password has been change please log in your new password.
    </div>
    
    <div
      v-if="isShowError"
      class="alert alert-danger alert-outline alert-dismissible fade show"
      role="alert"
    >
      <i class="uil uil-exclamation-octagon font-size-16 text-danger me-2"></i>
      {{ errorMessage }}
      <button type="button" class="btn-close" @click="closeError"></button>
    </div>

    <b-button
      class="w-100"
      variant="primary"
      :disabled="isLoginLoading"
      @click="gotoLogin"
    >
      <span
        v-if="isLoginLoading"
        class="spinner-grow spinner-grow-sm"
        role="status"
        aria-hidden="true"
      ></span>
      Log in now
    </b-button>
  </div>
</template>

<script>
import { authMethods } from "@/state/helpers";

export default {
  props: ["username", "password"],
  data() {
    return {
      isShowError: false,
      errorMessage: null,
      isLoginLoading: false,
    };
  },
  methods: {
    ...authMethods,
    gotoLogin(){
      this.$router.push({ name: 'login' });
    }
  },
};
</script>

<style>
.success-icon {
  width: 40px;
  height: 40px;
}
</style>